import { Link } from 'react-router-dom';
import Icon from './Icon';
import { effectiveRating, computeBaseOverall } from '../lib/balance';
import { formLabel } from '../lib/form';

export default function PlayerRow({ player, canEdit, onEdit, onDelete, onToggleAdmin, profileTo }) {
  const rating = effectiveRating(player);
  const base = computeBaseOverall(player.attributes);
  const form = formLabel(player.form);
  const drift = rating - base;

  return (
    <div className="player-row">
      <div
        className="player-row__rating"
        title={`Attributes ${base.toFixed(1)} · results ${(Number(player.rating_offset) || 0) >= 0 ? '+' : ''}${(Number(player.rating_offset) || 0).toFixed(2)} · form ${(Number(player.form) || 0) >= 0 ? '+' : ''}${(Number(player.form) || 0).toFixed(2)}`}
      >
        {rating.toFixed(1)}
      </div>

      <div className="player-row__main">
        <div className="player-row__nameline">
          {profileTo ? (
            <Link to={profileTo} className="player-row__name player-row__name--link">
              {player.name}
            </Link>
          ) : (
            <span className="player-row__name">{player.name}</span>
          )}
          {player.role === 'admin' && <span className="chip chip--admin">Admin</span>}
          {!player.profile_id && <span className="chip">Guest</span>}
          {form && (
            <span className={`chip chip--${form.tone}`} title={`Form ${drift > 0 ? '+' : ''}${drift.toFixed(2)}`}>
              {form.text}
            </span>
          )}
          {player.bestPosition && <span className="chip">Best {player.bestPosition}</span>}
        </div>
        <div className="player-row__meta">
          {player.positions?.length ? player.positions.join(' · ') : 'No position set'}
        </div>
      </div>

      {(canEdit || onToggleAdmin) && (
        <div className="player-row__actions">
          {onToggleAdmin && (
            <button
              type="button"
              className={`icon-btn ${player.role === 'admin' ? 'icon-btn--on' : ''}`}
              onClick={onToggleAdmin}
              aria-label={player.role === 'admin' ? `Remove admin from ${player.name}` : `Make ${player.name} an admin`}
              title={player.role === 'admin' ? 'Remove admin' : 'Make admin'}
            >
              <Icon name="shield" size={16} />
            </button>
          )}
          {canEdit && (
            <button type="button" className="icon-btn" onClick={onEdit} aria-label={`Edit ${player.name}`}>
              <Icon name="pencil" size={16} />
            </button>
          )}
          {canEdit && onDelete && (
            <button
              type="button"
              className="icon-btn icon-btn--danger"
              onClick={onDelete}
              aria-label={`Remove ${player.name}`}
            >
              <Icon name="trash" size={16} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
